import React, { useMemo, useState } from "react";
import { encryptStr, encryptUrlParams } from "../../Common/utils/extraFunctions";
import {
  FileDoneOutlined,
  CalendarOutlined,
  FolderOutlined,
  RobotOutlined,
  FormOutlined,
  EditOutlined,
  ClusterOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import {  message, Tooltip } from "antd";
import styles from "../styles/panelComp.module.css";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PropertyDocsModal } from "./PropertyDocsModal";
import { ClientPortaModal } from "../../Rtd/component/ClientPortaModal";
import NotesDrawer from "./NotesDrawer";
import { IoSendSharp } from "react-icons/io5";
import { SignableAndReadOnly } from "./SignableAndReadOnly";
import { PropertyImgs } from "./PropertyImgs";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";
import { checkIfDisabled, disabledTransactionText, isSellingNotExecutedFunc } from "../../Common/commondata/commonData";
import EditAgentsModal from "./EditAgentsModal";
import axios from "axios";
import { getAgentsArrayFromIndividualTxnData } from "./helper";
import { PropertyHandlers } from "../state/actions";
import PropertyInfo from "./PropertyInfo";
import { useEffect } from "react";
import { MdOutlineHistoryEdu } from "react-icons/md";
import { GrCompliance } from "react-icons/gr";
import ChecklistTable from "../../Common/components/ChecklistTable";
import TitlecompanyModal from "../../Rtd/component/TitlecompanyModal";
import { isAtleastOneClientPresent } from "../../DocumentSection/utils/helper";

const initialModalOpenState = {
  propertyDocs: false,
  noteDrawervisible:false,
  isEmailModalVisible:false,
  isAllEmailsModalOpen: false,
  titleCompany: false,
  openTable: false
}


const PanelComp = ({ item, section, filterSort, onlyOptions }) => {
  const delegate = (section === "DELEGATE");
  const bos = (section === "BOS");
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const agentDetails = item?.currentAgentId;
  const [isModalOpen, setIsModalOpen] = useState({
    ...initialModalOpenState
  });
   const [nestedModalOpen, setNestedModalOpen] = useState({
      isUploadDocsModal: false,
      isEmailModalVisible: false,
      isLegendOpen: false,
      sendMultipleDoc:false,
      isclearTransactionLaneData:false,
      resureSignDoc:false,
      isEditNameModalOpen: false,
      editDocDetails: {},
    });
  const [page, setPage] = useState([1]);
  const [tabSelect, setTabSelect] = useState("1");
  const isWeb = true;

  // states for modals need to be optimized later
  const [showmodal, setshowModal] = useState(false);

  // Client Portal modal
  const clientNullCheck = ({clientIds}) => {
    for(let ele of clientIds){
      if(ele?.isCorp){
        for(let signer of ele?.signers){
          if(!signer?.personId){
            return true;
          }
        }
      }
      else{
        if(!ele?.personId){
          return true;
        }
      }
    }
    return false
  }

  // Client Portal modal
  const handledataClick = () => {
    if (item?.isOffer && !isAtleastOneClientPresent(item.buyerIds)) {
      message.info("Please add at least one buyer to this offer to open the Client Portal.");
      return;
    }
    if (item?.isProperty && !isAtleastOneClientPresent(item.sellerIds)) {
      message.info("Please add at least one seller to this offer to open the Client Portal.");
      return;
    }
    setshowModal(true);
    dispatch(PropertyHandlers.resetPropertyDocs());
  };
 
  // Notes drawer
  const closeDrawerOfNotes = () => {
    setIsModalOpen({...isModalOpen,noteDrawervisible:false});
  };

  //Property Doc Method
  const handlePropertyDocClick = () => {
    setIsModalOpen({ propertyDocs: true });
  }
  const handleOpenTitleCompanyModal = () => {
    setIsModalOpen({...initialModalOpenState, titleCompany: true });
  }


  //Task And Calendar Method
  const handleTaskAndCalendarClick = () => {
    const encryptedOwnerId = encryptUrlParams(agentDetails?._id);
    if (delegate) {
      if(item?.isProperty){
        history.push(`/account/delegates/transactions/sTask/${encryptStr(item?.offerId)}?ref=${encryptedOwnerId}`);
      }
      else{
        history.push(`/account/delegates/transactions/bTask/${encryptStr(item?.offerId)}?ref=${encryptedOwnerId}`);
      }
    }
    else{
      if(item?.isProperty){
        history.push({
            pathname: `/transactions/sTask/${encryptStr(item?.offerId)}` + (bos ? `?ref=${encryptedOwnerId}` : ""),
        });
      }else{
        history.push({
          pathname: `/transactions/bTask/${encryptStr(item?.offerId)}` + (bos ? `?ref=${encryptedOwnerId}` : ""),
        });
      }
    }
  }


  const handleDashboardRedirection = () => {
    const encryptedOwnerId = encryptUrlParams(agentDetails?._id);
    if (delegate) {
      if (item?.isProperty) {
      history.push(`/account/delegates/transactions/sDashboard/${encryptStr(item.offerId)}?ref=${encryptedOwnerId}`);
      }
      else if (item?.isOffer) {
        const encryptedOwnerId = encryptUrlParams(agentDetails?._id);
        history.push(`/account/delegates/transactions/bDashboard/${encryptStr(item.offerId)}?ref=${encryptedOwnerId}`);
      }
    }
    else{
      if(item?.isProperty){
        history.push(`/transactions/sDashboard/${encryptStr(item.offerId)}` + (bos ? `?ref=${encryptedOwnerId}` : ""));
      }
      else if(item?.isOffer){
        history.push(`/transactions/bDashboard/${encryptStr(item.offerId)}` + (bos ? `?ref=${encryptedOwnerId}` : ""));
      }
    }
  }

  const handleSendDocument = () => {
   const role=item?.isProperty ? "SELLER" : "BUYER"
    let unmounted = {
      value: false
    };
    let source = axios.CancelToken.source();
      const delegateSide = (section === "DELEGATE") && role;
      dispatch(transactionLaneDataHandle.getIndividualTransaction({ offerId: item?.offerId, propertyId: item?.propertyId, unmounted, source, delegateSide, delegateOwnerId: (delegateSide || bos) && item?.currentAgentId?._id, screenType: bos && "BOS" }));
     setIsModalOpen({...isModalOpen,isEmailModalVisible:true, sendMultipleDoc:true, isclearTransactionLaneData:true})
  }
  
  const detailsData = {
    ...(item?.offerId ? { offerId: item?.offerId } : {}),
    ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
    accessibleFor: (item?.isProperty) ? "SELLER_AGENT" : "BUYER_AGENT",
    ...((delegate) ? {delegateSide: (item.isProperty)? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id} : (bos ? {delegateOwnerId: agentDetails?._id, screenType: "BOS"} : {})),
  };

  const isSellingNotExecuted = isSellingNotExecutedFunc({item});

  const handlePropertyInfoModal = () => {
    dispatch(PropertyHandlers.getOwnersInfo(item?.selectedOwnerId))
    setIsModalOpen({...isModalOpen,propertyInfoModalOpen:true})
  }

  
useEffect(() => {
  const modalOpenObj = JSON.parse(localStorage.getItem("modalOpen")) || {};
  const { openModal, openingFrom, offerId } = modalOpenObj;
  if (openModal && openingFrom === "Property_Doc" && offerId === item?.offerId) {
    setIsModalOpen((prev) => ({ ...prev, propertyDocs: true }));
    localStorage.removeItem("modalOpen");
  }
  return () => {
    if (openModal && openingFrom === "Property_Doc" && offerId === item?.offerId) {
      localStorage.removeItem("modalOpen");
    }
  };
}, []);


  const redirectToEmailLogsPage = (record) => {
    let buildData = {
      builtForId: agentDetails?._id,
      key: agentDetails?._id,
      openFor: (record?.isProperty) ? "SELLER" : "BUYER",
      builtForSection: "EMAIL_LOGS",
      ...(record?.propertyId ? { propertyId: record?.propertyId } : {}),
      ...(record?.offerId ? { offerId: record?.offerId } : {}),
      fullAddress: record?.address,
      token: localStorage.getItem("userAuth"),
      ...(delegate ? { delegateOwnerId: agentDetails?._id } : {}),
    };

    dispatch(PropertyHandlers.emailLogsUrlShorthandApiCalling(buildData, location?.pathname));
  };

  const openEmailLogs = (e) => {
    e.stopPropagation();
    redirectToEmailLogsPage(item);
  }

  const notAllowedObj = {cursor: "not-allowed", color: "rgb(184, 184, 184)"};
  return (
    <div className={styles.panelCompBox}>
      {/* various Modals here ...   */}
      {/* PropertyDocs Modal  */}
      {isModalOpen?.propertyDocs && (
        <PropertyDocsModal
          isModalOpen={isModalOpen}
          section={section}
          setIsModalOpen={setIsModalOpen}
          role={(item?.isProperty) ? "SELLER" : "BUYER"}
          item={item}
          isWeb={isWeb}
          tabSelect={tabSelect}
          setTabSelect={setTabSelect}
          setNestedModalOpen={setNestedModalOpen}
          nestedModalOpen={nestedModalOpen}
        />
      )}
      {isModalOpen?.titleCompany && (
        <TitlecompanyModal
          isModalOpen={isModalOpen}
          section={section}
          setIsModalOpen={setIsModalOpen}
          clientRole={(item?.isProperty) ? "SELLER" : "BUYER"}
          getCoordinateItem={item}
        />
      )}

      {/* Send Document Modal */}
      <SignableAndReadOnly
        role={item?.isProperty ? "SELLER" : "BUYER"}
        source={item?.isProperty ? "SELLING_DRAFT" : "BUYING_DRAFT"}
        section={section}
        nestedModalOpen={isModalOpen}
        setNestedModalOpen={setIsModalOpen}
        selectedData={item}
        docSelected={false}
        documentId={item?.isProperty ? item?._id : item?.CBSRId}
        delegateOwnerId={(delegate || bos) && item?.currentAgentId?._id}
        page={page}
        setPage={setPage}
      />

      {/* Client portal Modal */}
      {showmodal && !isModalOpen.isEmailPresent &&
        <ClientPortaModal
          personId={item?.currentAgentId?._id}
          showmodal={showmodal}
          Role={(item?.isOffer) ? "BUYER" : "SELLER"}
          offerid={item?.offerId}
          propertyId={item?.propertyId }
          delegateSide={delegate && ((item?.isOffer) ? "BUYER" : "SELLER")}
          delegateOwnerId = {agentDetails?._id}
          setIsModalOpen={setIsModalOpen}
          clientNullCheck={clientNullCheck}
          isModalOpen={isModalOpen}
          filterSort={filterSort}
          selectedData={item}
          setShowModal={ setshowModal}
      />}
      

      {/* Notes Drawer  */}
      {isModalOpen?.noteDrawervisible &&
     ( <NotesDrawer
        addressForNotes={item && item?.address}
        noteDrawervisible={isModalOpen?.noteDrawervisible}
        closeDrawerOfNotes={closeDrawerOfNotes}
        detailsData={detailsData}
      />)}
      {/* Agent Edit Modal  */}
      {isModalOpen?.editAgentModalVisible &&
     ( <EditAgentsModal
        item={item}
        filterSort={filterSort}
        isModalOpen={isModalOpen}
        section={section}
        setIsModalOpen={setIsModalOpen}
      />)}

      {isModalOpen?.propertyInfoModalOpen && <PropertyInfo isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}

      {isModalOpen?.openTable && <ChecklistTable section={section} checklistTable={isModalOpen} setChecklistTable={setIsModalOpen} client={item?.isProperty ? "SELLER" : "BUYER"} delegateSide={delegate} currentAgentDetails={agentDetails} origin={"PANEL_COMP"} item={item} />}

      {/* heading for address  */}
      <div className={onlyOptions ? styles.transactionListDetail : styles.transactionDetail}>
        {!onlyOptions && <div>
          <PropertyImgs currentlySelectedData={item} />
          {(item?.isOffer && item?.selectedOwnerId) && <span className={styles.propertyInfo} onClick={handlePropertyInfoModal}>Public Record</span>}
        </div>}
        <div className={`${styles.secondDetail} ${onlyOptions ? styles.secondListGird : styles.secondDisplayGird }`}>
          {
            ((item?.isProperty && isSellingNotExecuted) || item?.isOffer || item?.status === "DRAFT") && <div
              className={styles.secondDetailList}
              style={(item?.offerId) ? {} : notAllowedObj}
              {...((item?.offerId) ? {onClick: handleDashboardRedirection} : {})}
            >
              <FileDoneOutlined />
              <span>Transaction Dashboard</span>
            </div>
          }
          {
             <div
                className={styles.secondDetailList}
                onClick={handlePropertyDocClick}
              >
                <FolderOutlined />
                <span>
                  Property Docs
                </span>
              </div>
          }
          {
           ((item?.isProperty && isSellingNotExecuted) || (((item?.status === "ACCEPTED") || (item?.status === "TERMINATED")) && item?.isOffer)) && <div className={styles.secondDetailList}
                style={(item?.offerId || item?.isOffer) ? (item?.isProperty && (item?.status !== "ACCEPTED" && item?.status !== "TERMINATED")) ? notAllowedObj :  {} : notAllowedObj}
                {...(((item?.propertyStatus === "ACCEPTED" || item?.actualOfferStatus === "ACCEPTED" || item?.status === "ACCEPTED" || item?.status === "TERMINATED") || item?.isOffer ) ? {onClick: handleTaskAndCalendarClick} : {})}
            >
                <CalendarOutlined />
                <span>Task/Calendar</span>
              </div>
          }

          <div className={styles.secondDetailList} onClick={handledataClick}>
            <RobotOutlined />
            <span>Client Portal</span>
          </div>

          <div className={styles.secondDetailList} onClick={handleSendDocument}>
            <IoSendSharp/>
            <span>Send Document</span>
          </div>
          <div className={styles.secondDetailList} onClick={openEmailLogs}>
            <MdOutlineHistoryEdu />
            <span>Email Logs</span>
          </div>
          {!item?.isProperty && <div className={styles.secondDetailList} onClick={() => {setIsModalOpen({...isModalOpen,noteDrawervisible:true});}}>
            <FormOutlined />
            <span>Notes</span>
          </div>}
          {(item?.offerId) && <div className={styles.secondDetailList} onClick={() => {setIsModalOpen({...isModalOpen,openTable:true});}}>
            <GrCompliance />
            <span>Compliance Report</span>
          </div>}
          {/* {(item?.isProperty && isSellingNotExecuted) && !item?.offerId && <div className={styles.secondDetailList} onClick={() => {setIsModalOpen({...isModalOpen, editAgentModalVisible:true});}}>
            <EditOutlined />
            <span>Edit Broker-Agents</span>
          </div>} */}
            {
            ((item?.isProperty && isSellingNotExecuted) || item?.isOffer || item?.status === "DRAFT") && <div
              className={styles.secondDetailList}
              style={(item?.offerId) ? {} : notAllowedObj}
              {...((item?.offerId) ? {onClick: handleOpenTitleCompanyModal} : {})}
            >
              <TeamOutlined />
              <span>Title & Affliates</span>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default PanelComp;
